<template>
  <v-row>
    <v-col cols="12">
      <label>Concepto</label>
      <v-radio-group :value="retro.concepto" row hide-details readonly>
        <v-radio label="NI" :value="1"></v-radio>
        <v-radio label="RI" :value="2"></v-radio>
      </v-radio-group>
    </v-col>

    <v-col cols="12">
      <label>Evaluó: </label><br/>
      <b>{{ retro.evalua }}</b>
      <br/>
      <br/>

      <template v-if="retro.concepto == 2">
        <label>Plantel: </label><br/>
        <b>{{ retro.plantel }}</b>
      </template>
      <template v-else>
        <label>Evaluado: </label><br/>
        <b>{{ retro.evaluado }}</b>
      </template>
      <br/>
      <br/>

      <label>Calificación: </label><br/>
      <v-chip small dark :color="colorCalificacion">{{ calificacion !== null ? calificacion : '—' }}</v-chip>
      <br/>
      <br/>

      <label>Estatus: </label><br/>
      <v-chip v-if="retro.estatus == 0" small dark color="blue">Asignado</v-chip>
      <v-chip v-if="retro.estatus == 1" small dark color="green">Aceptado</v-chip>
      <v-chip v-if="retro.estatus == 2" small dark color="black">Rechazado</v-chip>
      <br/>
      <br/>

      <template v-if="retro.mensaje_rechazo">
        <label>Mensaje Rechazo: </label><br/>
        <b>{{ retro.mensaje_rechazo }}</b>
      </template>
    </v-col>

    <v-col cols="12">
      <v-card class="shadowCard">
        <v-card-title class="text-subtitle-1">{{ esFormatoComercial(retro) ? '1. Evaluación general del vendedor' : 'Bandeja de entrada de WhatsApp' }}</v-card-title>
        <v-card-text class="black--text">
          <v-row>
            <v-col cols="12" md="6" class="mb-4">
              <v-img :src="url + retro.foto" contain max-height="300" @click="verImagen( retro.foto )"/>
            </v-col>

            <v-col cols="12" md="6">
              <template v-if="esFormatoComercial(retro)">
                <div v-for="pregunta in preguntasGenerales" :key="'det-'+pregunta.key" class="mb-2">
                  <label>{{ pregunta.texto }}</label>
                  <v-radio-group :value="retro[pregunta.key]" row dense hide-details readonly class="mt-0 mb-2">
                    <v-radio label="SI" :value="1"></v-radio>
                    <v-radio label="NO" :value="2"></v-radio>
                  </v-radio-group>
                </div>
                <audio-retro v-if="retro.eval_audio" :value="retro.eval_audio" label="Audio de la evaluación general" readonly campo="eval_audio" :registro-id="retro.idretroalimentacion" :transcripcion="retro.eval_audio_txt" transcribible></audio-retro>
              </template>
              <template v-else>
                <template v-if="retro.concepto == 1">
                  <label>¿Cuenta con mensajes sin leer de <b>más de una hora?</b></label>
                  <v-radio-group :value="retro.p1" row dense hide-details readonly class="mb-2 mt-0">
                    <v-radio label="SI" :value="1"></v-radio>
                    <v-radio label="NO" :value="2"></v-radio>
                  </v-radio-group>

                  <label>¿Cuenta con prospectos <b>en visto?</b></label>
                  <v-radio-group :value="retro.p2" row dense hide-details readonly class="pt-0 mt-0">
                    <v-radio label="SI" :value="1"></v-radio>
                    <v-radio label="NO" :value="2"></v-radio>
                  </v-radio-group>
                </template>

                <v-textarea
                  :value="retro.p3"
                  :rows="6"
                  auto-grow
                  filled
                  dense
                  readonly
                  label="Retroalimentación"
                ></v-textarea>
                <audio-retro v-if="retro.p3_audio" :value="retro.p3_audio" label="Audio de la retroalimentación" readonly campo="p3_audio" :registro-id="retro.idretroalimentacion" :transcripcion="retro.p3_audio_txt" transcribible></audio-retro>
              </template>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12" v-for="(folio, i) in (retro.contactos || [])" :key="'det-contacto-'+i">
      <v-card class="shadowCard">
        <v-card-title class="text-subtitle-1">{{ esFormatoComercial(retro) ? '2. Evaluación del seguimiento — ' : '' }}Contacto #{{ i + 1 }}</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <div v-if="retro.concepto == 1"><b>Folio:</b> {{ folio.folio }}</div>
              <div v-if="retro.concepto == 2"><b>Alumno:</b> {{ folio.alumno }}</div>
              <b>Telefono:</b> {{ folio.telefono }}<br/>
            </v-col>

            <v-col cols="12" md="6" class="mb-4">
              <v-img :src="url + folio.foto" contain aspect-ratio="2" @click="verImagen( folio.foto )" />
            </v-col>

            <v-col cols="12" md="6">
              <template v-if="esFormatoComercial(retro)">
                <div v-for="pregunta in preguntasSeguimiento" :key="'det-seg-'+i+'-'+pregunta.key" class="mb-2">
                  <label>{{ pregunta.texto }}</label>
                  <v-radio-group :value="folio[pregunta.key]" row dense hide-details readonly class="mt-0 mb-2">
                    <v-radio label="SI" :value="1"></v-radio>
                    <v-radio label="NO" :value="2"></v-radio>
                  </v-radio-group>
                </div>
              </template>
              <template v-else>
                <div v-for="pregunta in (retro.concepto == 1 ? preguntasAnterioresNI : preguntasAnterioresRI)" :key="'det-ant-'+i+'-'+pregunta.key">
                  <label>{{ pregunta.texto }}</label>
                  <v-radio-group :value="folio[pregunta.key]" row dense hide-details readonly class="mt-0 mb-4">
                    <v-radio label="SI" :value="1"></v-radio>
                    <v-radio label="NO" :value="2"></v-radio>
                  </v-radio-group>
                </div>
              </template>

              <v-textarea
                :value="folio.retroalimentacion"
                :rows="6"
                auto-grow
                filled
                dense
                readonly
                label="Retroalimentación"
              ></v-textarea>
              <audio-retro v-if="folio.retro_audio" :value="folio.retro_audio" label="Audio de la retroalimentación" readonly campo="retro_audio" :registro-id="folio.idretro_detalle" :transcripcion="folio.retro_audio_txt" transcribible></audio-retro>

              <v-divider class="my-2"></v-divider>

              <div class="font-weight-medium">Audio del chat seleccionado</div>
              <div v-if="folio.audio_numero">Audio #{{ folio.audio_numero }}</div>
              <div v-else class="grey--text text--darken-1">Sin audio seleccionado.</div>

              <div v-if="folio.audio_url" class="mt-2">
                <audio :src="folio.audio_url" controls style="width: 100%;"></audio>
              </div>

              <v-textarea
                v-if="folio.audio_comentario"
                :value="folio.audio_comentario"
                :rows="3"
                auto-grow
                filled
                dense
                class="mt-2"
                label="Comentario del audio"
                readonly
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12" v-if="esFormatoComercial(retro)">
      <v-card class="shadowCard">
        <v-card-title class="text-subtitle-1">3. Retroalimentación general</v-card-title>
        <v-card-text>
          <v-textarea
            :value="retro.p3"
            :rows="6"
            auto-grow
            filled
            dense
            readonly
            label="Retroalimentación"
          ></v-textarea>
          <audio-retro v-if="retro.p3_audio" :value="retro.p3_audio" label="Audio de la retroalimentación general" readonly campo="p3_audio" :registro-id="retro.idretroalimentacion" :transcripcion="retro.p3_audio_txt" transcribible></audio-retro>
        </v-card-text>
      </v-card>
    </v-col>

    <v-dialog v-model="dialogImagen" max-width="1000px">
      <v-card class="elevation-0">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn fab small text @click="dialogImagen = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-img :src="url + imagen" contain max-height="80vh"></v-img>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from 'axios'
import AudioRetro from '@/components/operaciones/AudioRetro.vue'
import {
  PREGUNTAS_GENERALES,
  PREGUNTAS_SEGUIMIENTO,
  esFormatoComercial,
  calificacionRetro,
  colorCalificacionRetro,
} from '@/constants/retroalimentacion-comercial'

export default {
  name: 'DetalleRetroalimentacion',

  components: { AudioRetro },

  props: {
    retro: { type: Object, required: true },
  },

  data: () => ({
    url: axios.defaults.baseURL + 'imagenes-retro/',
    imagen: null,
    dialogImagen: false,
    preguntasGenerales: PREGUNTAS_GENERALES,
    preguntasSeguimiento: PREGUNTAS_SEGUIMIENTO,
    preguntasAnterioresNI: [
      { key: 'valor1', texto: '¿Hay mensajes Robotizados?' },
      { key: 'valor2', texto: '¿El tiempo de respuesta entre el cliente y el asesor es adecuado?' },
      { key: 'valor3', texto: '¿El asesor usa herramientas adicionales en su seguimiento como audios e imágenes?' },
      { key: 'valor4', texto: '¿El asesor usa los documentos de la escuela de manera correcta (Plan de estudios, calendarios de pago , métodos de pago)?' },
      { key: 'valor5', texto: '¿El asesor se dirige con formalidad al prospecto?' },
    ],
    preguntasAnterioresRI: [
      { key: 'valor6', texto: '¿Hay seguimientos Robotizados?' },
      { key: 'valor7', texto: '¿El tiempo de respuesta entre el alumno y el asesor académico es adecuado?' },
      { key: 'valor8', texto: '¿El asesor resuelve las situaciones y dudas del alumno?' },
      { key: 'valor9', texto: '¿El asesor envia el recordatorio de pago en tiempo y forma?' },
      { key: 'valor10', texto: '¿El asesor se dijere de manera formal y educada con el alumno?' },
    ],
  }),

  computed: {
    calificacion () {
      return calificacionRetro(this.retro)
    },
    colorCalificacion () {
      return colorCalificacionRetro(this.calificacion)
    },
  },

  methods: {
    esFormatoComercial,

    verImagen (imagen) {
      this.imagen = imagen
      this.dialogImagen = true
    },
  },
}
</script>
